import { render, staticRenderFns } from "./course-edit.vue?vue&type=template&id=e405acf8&scoped=true"
import script from "./course-edit.vue?vue&type=script&lang=js"
export * from "./course-edit.vue?vue&type=script&lang=js"
import style0 from "./course-edit.vue?vue&type=style&index=0&id=e405acf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e405acf8",
  null
  
)

export default component.exports